module.exports = __webpack_public_path__ + "static/img/2gaojing1.9b5ad163.png";